import { render, staticRenderFns } from "./AccountBalanceChart.vue?vue&type=template&id=48025804&scoped=true"
import script from "./AccountBalanceChart.vue?vue&type=script&lang=ts"
export * from "./AccountBalanceChart.vue?vue&type=script&lang=ts"
import style0 from "./AccountBalanceChart.vue?vue&type=style&index=0&id=48025804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48025804",
  null
  
)

export default component.exports